import { render, staticRenderFns } from "./LibraryView.vue?vue&type=template&id=aff47d54&"
import script from "./LibraryView.vue?vue&type=script&lang=ts&"
export * from "./LibraryView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports